export default "__VITE_ASSET__Bv8wX975__"